"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _TableFooterActions = _interopRequireDefault(require("./TableFooterActions.style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*eslint-disable*/

var TableFooterActions = function TableFooterActions(_ref) {
  var onClear = _ref.onClear,
    clearLabel = _ref.clearLabel,
    selectedItems = _ref.selectedItems,
    footerActions = _ref.footerActions;
  return /*#__PURE__*/_react["default"].createElement(_TableFooterActions["default"], {
    isDisabled: !selectedItems
  }, onClear && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("a", {
    onClick: selectedItems ? onClear : function () {}
  }, clearLabel)), !R.isEmpty(footerActions) && footerActions.map(function (node) {
    return /*#__PURE__*/_react["default"].createElement("span", null, node);
  }));
};
TableFooterActions.defaultProps = {
  onClear: null,
  clearLabel: '',
  selectedItems: null,
  footerActions: []
};
TableFooterActions.propTypes = {
  onClear: _propTypes["default"].func,
  clearLabel: _propTypes["default"].string,
  selectedItems: _propTypes["default"].number,
  footerActions: _propTypes["default"].arrayOf(_propTypes["default"].node)
};
TableFooterActions.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableFooterActions",
  "props": {
    "onClear": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "clearLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "selectedItems": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "footerActions": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "node"
        }
      },
      "required": false
    }
  }
};
var _default = TableFooterActions;
exports["default"] = _default;